/* eslint-disable react/prop-types, camelcase */
import React from 'react';
import { withRouter } from 'react-router-dom';

import Breadcrumbs from '~/modules/coreUI/components/basic/Breadcrumbs';
import BreadcrumbsLinks from '~/modules/ecommerceCore/BreadcrumbsLinks';

// Home > TRACK_NAME

const SupportBreadcrumbs = props => (
  <Breadcrumbs
    crumbs={[
      BreadcrumbsLinks.HOME(),
      BreadcrumbsLinks.TRACKS(props.match.params.track),
    ]}
  />
);

export default withRouter(SupportBreadcrumbs);
